export const DEFAULT_FONT_COLOR="white";
export const DEFAULT_BACKGROUND="#21252A";
export const TITLE="Please approve transaction on mobile phone";